import React from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import { maritalStatuses } from 'presentation/model/constants';

class ExtraTabResponsibleForm extends React.Component {
    constructor(props) {
        super(props);

    }
    render() {
        let { form, handleChange, component } = this.props;
        return (
            <Container>
                <Row>
                    <Col>
                        <h4>Informações extra</h4>
                    </Col>
                </Row>
                <Row>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="maritalStatus">Estado civil</Form.Label>
                            <Form.Select
                                aria-label="Estado civil"
                                defaultValue={form.maritalStatus}
                                id="maritalStatus"
                                name="maritalStatus"
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="maritalStatusHelpBlock"
                                required
                            >
                                <option key="-1">Selecione</option>
                                {maritalStatuses.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                            </Form.Select>
                            <Form.Text id="maritalStatusHelpBlock" muted>
                                Defina a qual é estado civil
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="inep">Número INEP</Form.Label>
                            <Form.Control
                                type="text"
                                id="inep"
                                name="inep"
                                defaultValue={form.inep}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="inepHelpBlock"
                            />
                            <Form.Text id="inepHelpBlock" muted>
                                Informe número inep
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="nis">Número NIS</Form.Label>
                            <Form.Control
                                type="text"
                                id="nis"
                                name="nis"
                                defaultValue={form.nis}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="nisHelpBlock"
                            />
                            <Form.Text id="nisHelpBlock" muted>
                                Informe número nis
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="birthCertificate">Nº certidão de nascimento</Form.Label>
                            <Form.Control
                                type="text"
                                id="birthCertificate"
                                name="birthCertificate"
                                defaultValue={form.birthCertificate}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="birthCertificateHelpBlock"
                            />
                            <Form.Text id="birthCertificateHelpBlock" muted>
                                Informe nº certidão de nascimento
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="birthCertificateBook">Livro</Form.Label>
                            <Form.Control
                                type="text"
                                id="birthCertificateBook"
                                name="birthCertificateBook"
                                defaultValue={form.birthCertificateBook}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="birthCertificateBookHelpBlock"
                            />
                            <Form.Text id="birthCertificateBookHelpBlock" muted>
                                Informe livro
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="birthCertificatePage">Pagina</Form.Label>
                            <Form.Control
                                type="text"
                                id="birthCertificatePage"
                                name="birthCertificatePage"
                                defaultValue={form.birthCertificatePage}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="birthCertificatePageHelpBlock"
                            />
                            <Form.Text id="birthCertificatePageHelpBlock" muted>
                                Informe pagina
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="birthCertificateTermination">Termo</Form.Label>
                            <Form.Control
                                type="text"
                                id="birthCertificateTermination"
                                name="birthCertificateTermination"
                                defaultValue={form.birthCertificateTermination}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="birthCertificateTerminationHelpBlock"
                            />
                            <Form.Text id="birthCertificateTerminationHelpBlock" muted>
                                Informe termo
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="birthCertificateIssueDate">Data de emissão da cert. de nasc.</Form.Label>
                            <Form.Control
                                type="date"
                                id="birthCertificateIssueDate"
                                name="birthCertificateIssueDate"
                                defaultValue={form.birthCertificateIssueDate}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="birthCertificateIssueDateHelpBlock"
                            />
                            <Form.Text id="birthCertificateIssueDateHelpBlock" muted>
                                Informe a data de emissão da certidão  de nascimento
                            </Form.Text>
                        </div>
                    </Col>

                    <Col lg={8}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="birthCertificateNotaryOfficeName">Nome do cartório</Form.Label>
                            <Form.Control
                                type="text"
                                id="birthCertificateNotaryOfficeName"
                                name="birthCertificateNotaryOfficeName"
                                defaultValue={form.birthCertificateNotaryOfficeName}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="birthCertificateNotaryOfficeNameHelpBlock"
                            />
                            <Form.Text id="birthCertificateNotaryOfficeNameHelpBlock" muted>
                                Informe nome do cartório
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={8}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="birthCertificateNotaryOfficeCity">Município do cartório</Form.Label>
                            <Form.Control
                                type="text"
                                id="birthCertificateNotaryOfficeCity"
                                name="birthCertificateNotaryOfficeCity"
                                defaultValue={form.birthCertificateNotaryOfficeCity}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="birthCertificateNotaryOfficeCityHelpBlock"
                            />
                            <Form.Text id="birthCertificateNotaryOfficeCityHelpBlock" muted>
                                Informe município do cartório
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="birthCertificateNotaryOfficeState">UF do cartório</Form.Label>
                            <Form.Control
                                type="text"
                                id="birthCertificateNotaryOfficeState"
                                name="birthCertificateNotaryOfficeState"
                                defaultValue={form.birthCertificateNotaryOfficeState}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="birthCertificateNotaryOfficeStateHelpBlock"
                            />
                            <Form.Text id="birthCertificateNotaryOfficeStateHelpBlock" muted>
                                Informe uf do cartório
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={12}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="birthCertificateFatherName">Nome do pai como consta na certidão</Form.Label>
                            <Form.Control
                                type="text"
                                id="birthCertificateFatherName"
                                name="birthCertificateFatherName"
                                defaultValue={form.birthCertificateFatherName}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="birthCertificateFatherNameHelpBlock"
                            />
                            <Form.Text id="birthCertificateFatherNameHelpBlock" muted>
                                Informe nome do pai como consta na certidão
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={12}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="birthCertificateMotherName">Nome da mãe como consta na certidão</Form.Label>
                            <Form.Control
                                type="text"
                                id="birthCertificateMotherName"
                                name="birthCertificateMotherName"
                                defaultValue={form.birthCertificateMotherName}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="birthCertificateMotherNameHelpBlock"
                            />
                            <Form.Text id="birthCertificateMotherNameHelpBlock" muted>
                                Informe nome da mãe como consta na certidão
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="rg">Identidade</Form.Label>
                            <Form.Control
                                type="text"
                                id="rg"
                                name="rg"
                                defaultValue={form.rg}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="rgHelpBlock"
                            />
                            <Form.Text id="rgHelpBlock" muted>
                                Informe identidade
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="rgEmitter">Orgão emissor</Form.Label>
                            <Form.Control
                                type="text"
                                id="rgEmitter"
                                name="rgEmitter"
                                defaultValue={form.rgEmitter}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="rgEmitterHelpBlock"
                            />
                            <Form.Text id="rgEmitterHelpBlock" muted>
                                Informe orgão emissor
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="rgIssueDate">Data de emissão</Form.Label>
                            <Form.Control
                                type="date"
                                id="rgIssueDate"
                                name="rgIssueDate"
                                defaultValue={form.rgIssueDate}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="rgIssueDateHelpBlock"
                            />
                            <Form.Text id="rgIssueDateHelpBlock" muted>
                                Informe data de emissão
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="voterRegistration">Título de eleitor</Form.Label>
                            <Form.Control
                                type="text"
                                id="voterRegistration"
                                name="voterRegistration"
                                defaultValue={form.voterRegistration}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="voterRegistrationHelpBlock"
                            />
                            <Form.Text id="voterRegistrationHelpBlock" muted>
                                Informe título de eleitor
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="voterZone">Zona eleitoral</Form.Label>
                            <Form.Control
                                type="text"
                                id="voterZone"
                                name="voterZone"
                                defaultValue={form.voterZone}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="voterZoneHelpBlock"
                            />
                            <Form.Text id="voterZoneHelpBlock" muted>
                                Informe zona eleitoral
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="voterSection">Seção</Form.Label>
                            <Form.Control
                                type="text"
                                id="voterSection"
                                name="voterSection"
                                defaultValue={form.voterSection}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="voterSectionHelpBlock"
                            />
                            <Form.Text id="voterSectionHelpBlock" muted>
                                Informe seção
                            </Form.Text>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    };
}

export default ExtraTabResponsibleForm;